<portal-modal-header
  (onClose)="dismiss()"
  title="{{ 'sip-credentials.title' | portalTranslate }}"
></portal-modal-header>

<portal-modal-body>
  <portal-error-alert [error]="error"></portal-error-alert>

  <!-- SBC -->
  @if (showSbcData && rsbc != null) {
    <portal-card>
      <ng-container header>
        <h5>{{ 'sip-credentials.server' | portalTranslate }}</h5>
      </ng-container>
      <div class="">
        @if (rsbc2 != null) {
          <h6 class="">{{ 'sip-credentials.server.primary' | portalTranslate }}</h6>
        }
        <ng-container [ngTemplateOutlet]="sbcTmpl" [ngTemplateOutletContext]="{ rsbc: rsbc }"></ng-container>
      </div>

      <!-- SBC Redundant (for trunk) -->
      @if (rsbc2 != null) {
        <div class="">
          <h6 class="">
            {{ 'sip-credentials.server.secondary' | portalTranslate }}
            <i
              class="far fa-question-circle ms-1"
              [portalTippy]="'sip-credentials.server.secondary.info' | translate"
              placement="right"
            ></i>
          </h6>
          <ng-container
            [ngTemplateOutlet]="sbcTmpl"
            [ngTemplateOutletContext]="{ rsbc: rsbc2 }"
          ></ng-container>
        </div>
      }
    </portal-card>
  }

  <ng-template #sbcTmpl let-rsbc="rsbc">
    <div class="row">
      @let showHostDnsSrvTLS = rsbc.enableTLS && rsbc.sbc.hostDnsSrvTLS;
      @let showHostDnsSrvUDP = rsbc.enableUDP && rsbc.sbc.hostDnsSrvUDP;

      <!-- DNS-SRV (this is preferred to host variant) -->
      @if (showHostDnsSrvTLS || showHostDnsSrvUDP) {
        <div class="col-12 col-sm-6">
          <div class="form-group">
            <label class="form-label"
              >{{ 'enterprise.sbc.dns-srv' | portalTranslate }}
              <i
                class="far fa-question-circle ms-1"
                [portalTippy]="'sip-credentials.dns-srv.info' | translate"
                placement="right"
              ></i>
            </label>

            @if (showHostDnsSrvTLS) {
              <div>
                {{ 'enterprise.sbc.host.tls' | portalTranslate }}: <code>{{ rsbc.sbc.hostDnsSrvTLS }}</code>
                <portal-copy-to-clipboard [text]="rsbc.sbc.hostDnsSrvTLS"></portal-copy-to-clipboard>
              </div>
            }

            @if (showHostDnsSrvUDP) {
              <div>
                {{ 'enterprise.sbc.host.udp' | portalTranslate }}: <code>{{ rsbc.sbc.hostDnsSrvUDP }}</code>
                <portal-copy-to-clipboard [text]="rsbc.sbc.hostDnsSrvUDP"></portal-copy-to-clipboard>
              </div>
            }
          </div>
        </div>
      }

      @let showHostTLS = rsbc.enableTLS && rsbc.sbc.hostTLS;
      @let showHostUDP = rsbc.enableUDP && rsbc.sbc.hostUDP;

      <!-- Host -->
      @if (showHostTLS || showHostUDP) {
        <div class="col-12 col-sm-6">
          <div class="form-group">
            <label class="form-label">{{ 'enterprise.sbc.host' | portalTranslate }}</label>

            @if (showHostTLS) {
              <div>
                {{ 'enterprise.sbc.host.tls' | portalTranslate }}: <code>{{ rsbc.sbc.hostTLS }}</code>
                <portal-copy-to-clipboard [text]="rsbc.sbc.hostTLS"></portal-copy-to-clipboard>
              </div>
            }

            @if (showHostUDP) {
              <div>
                {{ 'enterprise.sbc.host.udp' | portalTranslate }}: <code>{{ rsbc.sbc.hostUDP }}</code>
                <portal-copy-to-clipboard [text]="rsbc.sbc.hostUDP"></portal-copy-to-clipboard>
              </div>
            }
          </div>
        </div>
      }

      @let showSipMediaPorts = rsbc.sbc.sipMediaPorts;

      <!-- SIP media ports -->
      @if (showSipMediaPorts) {
        <div class="col-12 col-sm-6">
          <div class="form-group">
            <label class="form-label"
              >{{ 'enterprise.sbc.sipMediaPorts' | portalTranslate }}
              <i
                class="far fa-question-circle ms-1"
                [portalTippy]="'enterprise.sbc.sipMediaPorts.info' | translate"
                placement="right"
              ></i>
            </label>

            <div>
              <code>{{ rsbc.sbc.sipMediaPorts }}</code>
              <portal-copy-to-clipboard [text]="rsbc.sbc.sipMediaPorts"></portal-copy-to-clipboard>
            </div>
          </div>
        </div>
      }
    </div>
  </ng-template>
  <portal-card>
    <ng-container header>
      <h5>{{ 'sip-credentials.credentials' | portalTranslate }}</h5>
    </ng-container>
    <div>
      <!-- SIP URI -->
      @if (sipUri != null) {
        <div class="form-group">
          <label>{{ 'sip-credentials.account' | translate }}</label>
          <div>
            <span>{{ sipUri }}</span>
            <portal-copy-to-clipboard [text]="sipUri"></portal-copy-to-clipboard>
          </div>
        </div>
      }
      <!-- SIP username -->
      @if (sipUsername != null) {
        <div class="form-group">
          <label>{{ 'sip-credentials.username' | translate }}</label>
          <div>
            <span>{{ sipUsername }}</span>
            <portal-copy-to-clipboard [text]="sipUsername"></portal-copy-to-clipboard>
          </div>
        </div>
      }
      <!-- SIP domain -->
      @if (sipDomain != null) {
        <div class="form-group">
          <label>{{ 'trunk.credentials.domain' | translate }}</label>
          <div>
            <span>{{ sipDomain }}</span>
            <portal-copy-to-clipboard [text]="sipDomain"></portal-copy-to-clipboard>
          </div>
        </div>
      }
      <!-- Password -->
      @if (showPassword) {
        <div class="form-group">
          <label>{{ 'sip-credentials.password' | portalTranslate }}</label>
          <div>
            @if (plainPassword != null) {
              <span>{{ plainPassword }}</span>
              <portal-copy-to-clipboard [text]="plainPassword"></portal-copy-to-clipboard>
            } @else {
              <i class="far fa-circle-notch fa-spin"></i>
            }
          </div>
        </div>
      }
    </div>
  </portal-card>
</portal-modal-body>

<portal-modal-footer [closeOnly]="true" (onCancel)="dismiss()"></portal-modal-footer>
